<template>
  <div v-bind:style="{ width: width + 'px' }">
      <svg :id="id" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 840.9 1000">
        <g>
          <path :fill="color" :stroke="color" d="M839.9,257.4c-0.6-26.8-1.2-52.5-1.2-77c0-19.3-15.8-35-35-35c-149.9,0-263.7-43.2-358.8-135.3c-13.4-13.4-35-13.4-49,0
		        c-95.1,92.2-208.8,135.3-358.8,135.3c-19.3,0-35,15.8-35,35c0,24.5-0.6,50.2-1.2,77c-4.7,251.4-11.7,595,407.8,740.8
		        c7.6,2.3,15.8,2.3,22.8,0C851,853,844.6,509.4,839.9,257.4L839.9,257.4z M420.5,927.7C61.1,797.6,66.4,511.7,71.6,259.2
		        c0-15.2,0.6-29.8,0.6-44.3c140-5.8,252-48.4,348.3-131.8c96.3,83.4,208.3,126,348.3,131.8c0,14.6,0.6,29.2,0.6,44.3
		        C774.6,511.7,779.8,797.6,420.5,927.7z"></path>
        </g>
        <line data-start="0" data-duration="100" class="k-logo-line" :stroke="color" x1="246.1" y1="636" x2="606.6" y2="636"></line>
        <line data-start="1" data-duration="20" class="k-logo-line" :stroke="color" x1="246.1" y1="434.7" x2="376.7" y2="566"></line>
        <line data-start="2" data-duration="5" class="k-logo-line" :stroke="color" x1="376.7" y1="566" x2="606.6" y2="338.5"></line>
      </svg>
  </div>
</template>

<script>
  import Vivus from 'vivus'
  import uuid from 'uuid/v4'
  
  export default {
    name: 'Logo',
    data() {
      return {
        id: null
      }
    },
    props: {
      width: {
        type: Number,
        default: 300
      },
      animation: {
        type: Boolean,
        default: false
      },
      color: {
        type: String,
        default: '#eeeeee'
      }
    },
    beforeMount: function () {
      this.id = uuid()
    },
    mounted: function () {
      if (this.animation) {
        new Vivus(this.id, {type: 'scenario-sync', duration: 10}, () => {})
      }
    }
  }
</script>

<style scoped>
  .k-logo-line {
    fill: none;
    stroke-width: 60;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
</style>
